import { Component, Input, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslationService } from '../../services/languages/translation.service';
import { AppState } from '../../../store/state.model';
import { NgRedux } from '@angular-redux/store';
import { Tss } from './model/tss.model';
import { formatDateString } from '../../helpers/utils';
import { ElementRef } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-tss--dialog-box',
    templateUrl: './tss-dialog-box.component.html',
    styleUrls: ['./tss-dialog-box.component.scss'],
    imports: [NgIf, MatTable, NgFor, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, MatDivider, TranslatePipe]
})
export class TssDialogBoxComponent {

  /**
  * @var displayedColumns list of columns to display for corresponding service
  **/
  public displayedColumns: string[];
  /**
* @var dataSource to store table data
**/
  public dataSource = [];
  /**
  * @var title to store the title
  **/
  public title: string;
  /**
 * @var note to store the footer note
 **/
  public note: string;
  /**
* @var noReport to store the translations if no records found
**/
  public noReport: string;
  /**
 * @var isReported stores true if records exist
 **/
  public isReported: boolean;
  /**
 * @var model stores respective model on condition
 **/
  public model: any;
  constructor(
    public dialogRef: MatDialogRef<TssDialogBoxComponent>,
    public translation: TranslationService,
    public router: Router,
    public ngRedux: NgRedux<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public route: ActivatedRoute,
    private elem: ElementRef
  ) {
    this.isReported = false;
    this.model = new Tss(data);
    this.loadData();
  }
  /**
  * @method close closes the dialog box
  * @returns void
  **/
  public close(): void {
    this.dialogRef.close();
  }

  /**
  * @method loadData to display list of records
  * @returns void
  **/
  public loadData(): void {
    this.title = this.model.form['title'];
    this.note = this.model.form['note'];
    this.noReport = this.model.form['report'];
    this.displayedColumns = this.model.form['columns'];
    this.isReported = this.model.isReported;
    this.dataSource = this.model.recordsData;
    const found = !!this.dataSource && this.dataSource.some(item => item.hasOwnProperty('outageStartDateString'));
    if (found) {
      this.dataSource.forEach((ele, index) => {
        this.dataSource[index].outageStartDateString = formatDateString(ele.outageStartDateString);
      });
    }
  }

  /**
  * @method containsChildNodes return true if the mat-cell has any child nodes
  **/
  public containsChildNodes() {
    const elements = this.elem.nativeElement.querySelectorAll('.table-cell');
    return elements[0].childNodes.length > 1;
  }
}
